import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  type ButtonProps,
} from '@mui/material';

export type Props = {
  title?: string;
  content?: string;
  isOpen: boolean;
  onConfirm: NonNullable<ButtonProps['onClick']>;
  onClose: NonNullable<ButtonProps['onClick']>;
};

export const RecoveryFromArchiveDialog: FC<Props> = ({
  title,
  content,
  isOpen,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
      <DialogTitle>{title || t('RestoringFromArchive')}</DialogTitle>
      <DialogContent>
        <DialogContentText color="textPrimary">
          {content || t('TheDataWillBeRestoredFromTheArchive')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onConfirm}>
          {t('Confirm')}
        </Button>
        <Button variant="outlined" onClick={onClose}>
          {t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
